/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerPatchPhoneMutationRequest,
  TelegramUsersControllerPatchPhoneMutationResponse,
  TelegramUsersControllerPatchPhone400,
  TelegramUsersControllerPatchPhone401,
  TelegramUsersControllerPatchPhone429,
} from '../types/TelegramUsersControllerPatchPhone.ts';

function getTelegramUsersPatchPhoneUrl() {
  const res = { method: 'PATCH', url: `/api/telegram/users/phone` as const };
  return res;
}

/**
 * {@link /api/telegram/users/phone}
 */
export async function telegramUsersPatchPhone(
  data: TelegramUsersControllerPatchPhoneMutationRequest,
  config: Partial<RequestConfig<TelegramUsersControllerPatchPhoneMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramUsersControllerPatchPhoneMutationResponse,
    ResponseErrorConfig<
      TelegramUsersControllerPatchPhone400 | TelegramUsersControllerPatchPhone401 | TelegramUsersControllerPatchPhone429
    >,
    TelegramUsersControllerPatchPhoneMutationRequest
  >({ method: 'PATCH', url: getTelegramUsersPatchPhoneUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
